import { Dialog, Transition } from "@headlessui/react";
import { Fragment } from "react";
import { BsArrowLeft } from "react-icons/bs";
import { FaTimes } from "react-icons/fa";

export default function Modal({ closeModal, isOpen, width, children, title }) {
  return (
    <>
      <Transition appear show={isOpen} as={Fragment}>
        <Dialog as='div' className='relative z-50' onClose={closeModal}>
          <Transition.Child
            as={Fragment}
            enter='ease-out duration-300'
            enterFrom='opacity-0'
            enterTo='opacity-100'
            leave='ease-in duration-200'
            leaveFrom='opacity-100'
            leaveTo='opacity-0'
          >
            <div className='fixed inset-0 bg-black bg-opacity-25' />
          </Transition.Child>

          <div className='fixed inset-0 overflow-y-auto'>
            <div className='flex min-h-full items-center justify-center p-4 text-center'>
              <Transition.Child
                as={Fragment}
                enter='ease-out duration-300'
                enterFrom='opacity-0 scale-95'
                enterTo='opacity-100 scale-100'
                leave='ease-in duration-300'
                leaveFrom='opacity-100 scale-100'
                leaveTo='opacity-0 scale-95'
              >
                <Dialog.Panel
                  className={`w-full ${
                    width ? width : "max-w-4xl"
                  } transform overflow-hidden rounded-2xl bg-white p-6 text-left align-middle shadow-xl transition-all`}
                >
                  <div className='flex-btn mb-8 w-full gap-2'>
                    <div className='flex flex-row items-center'>
                      <button
                        onClick={closeModal}
                        className='flex-colo h-14 w-14 rounded-md bg-white font-bold text-black'
                      >
                        <BsArrowLeft className='h-6 w-6 font-bold' />
                      </button>
                      <h1 className='text-md ml-2 font-semibold'>{title}</h1>
                    </div>
                    {/* <button
                      onClick={closeModal}
                      className="w-14 h-12 bg-dry text-red-600 rounded-md flex-colo"
                    >
                      <FaTimes />
                    </button> */}
                  </div>
                  {children}
                </Dialog.Panel>
              </Transition.Child>
            </div>
          </div>
        </Dialog>
      </Transition>
    </>
  );
}
